import SetPasswordMain from './components/SetPasswordMain';

export default {
	SetPasswordMain
}